/* eslint-disable no-shadow */
import React, { useState } from 'react';

import styled, { css } from 'styled-components';
import { theme, Icon, DatePicker, Select } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getFormatedDate } from '@helpers';
import { useSelector } from 'react-redux';

import {
  StyledFilter,
  SyledDateContainer,
  IconButton,
  StyledDateFilter,
  StyledDatePicker,
} from './CommonComponents';

const fontTypes = {
  title: css`
    ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
    line-height: normal;
    color: ${theme.colors.gray800};
  `,
  clean: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: 1.71;
    text-align: center;
    color: ${theme.colors.gray500};
  `,
};

const LayoutMobile = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const LayoutTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  align-items: center;
`;

const LayoutSelectTypeMobile = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  min-width: 312px;
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;
const LayoutSelectCalendar = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  min-width: 312px;
`;

const TitleMobile = styled.div`
  ${fontTypes.title}
  margin-left: 20px;
  align-content: center;
  align-items: center;
`;
const LayoutIcon = styled.div`
  display: flex;
  cursor: pointer;
  align-content: center;
  align-items: center;
`;

const IconMobile = styled(Icon)`
  width: 24px;
  height: 24px;
`;
export const CleanMobile = styled.div(
  ({ theme }) => css`
    display: flex;
    min-width: 120px;
    width: 156px;
    height: 56px;
    ${fontTypes.clean};
    text-align: center;
    color: ${(props) =>
      props.btnActive ? `${theme.colors.gbrand500}` : `${theme.colors.gray500}`};
    font-size: ${(props) => (props.btnActive ? '16px' : '14px')};
    justify-items: center;
    align-items: center;
    cursor: ${(props) => (props.btnActive ? 'pointer' : '')};
    justify-content: center;
  `
);

export const ApplyMobile = styled.div(
  ({ theme }) => css`
    display: flex;
    min-width: 120px;
    width: 156px;
    height: 56px;
    border-radius: 4px;
    background-color: ${(props) =>
      props.btnActive ? `${theme.colors.gbrand500}` : `${theme.colors.gray400}`};
    box-shadow: ${(props) => (props.btnActive ? '0 8px 28px 0 rgba(0, 0, 0, 0.24)' : '')};
    ${fontTypes.title};
    text-align: center;
    justify-content: center;
    align-items: center;
    color: ${(props) => (props.btnActive ? '#ffffff' : 'rgba(162, 167, 186, 0.87)')};
    font-size: ${(props) => (props.btnActive ? '16px' : '14px')};
    cursor: ${(props) => (props.btnActive ? 'pointer' : '')};
  `
);

const LayoutBottomMobile = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  margin: auto;
  margin-bottom: 44px;
`;

const StyledSelect = styled(Select)`
  width: 100% !important;
  ${theme.breakpoint('md')} {
    max-width: 312px !important;
  }
`;

const FiltersMobile = ({
  handleResetMobile,
  onClickApplyMobile,
  onClickBackMobile,
  onButtons,
  valueSelectMobile,
  onChangeValueSelectType,
  optionsSelect,
  filterApplyCalendarMobile,
  handleChangeCalendar,
  intervalDateCalendar,
  handleResetCalendarMobile,
  intervalDateInit,
  intervalDateFinish,
  disabledCalendarMobile,
  disabledSelectTypeMobile,
  limitsDaysMobile,
  allowedFilterByType,
}) => {
  const { t } = useTranslation();

  const [showCalendar, setShowCalendar] = useState(false);

  const { created_at: createdAt } = useSelector((state) => state.login.merchant);

  return (
    <LayoutMobile>
      <LayoutTitle>
        <LayoutIcon onClick={onClickBackMobile}>
          <IconMobile icon="ic_backarrow" />
        </LayoutIcon>
        <TitleMobile>{t('lastMovements.filters')}</TitleMobile>
      </LayoutTitle>
      {allowedFilterByType && (
        <LayoutSelectTypeMobile disabled={disabledSelectTypeMobile}>
          <StyledSelect
            options={optionsSelect}
            value={valueSelectMobile}
            placeholder={t('reportsScreen.filter.type')}
            onChange={onChangeValueSelectType}
            disabled={false}
            zIndex="1"
          />
        </LayoutSelectTypeMobile>
      )}
      <LayoutSelectCalendar>
        <StyledFilter>
          <SyledDateContainer disabled={disabledCalendarMobile}>
            <IconButton onClick={() => setShowCalendar((state) => !state)}>
              <Icon icon="ic-calendar" />
            </IconButton>
            <StyledDateFilter type="button" onClick={() => setShowCalendar((state) => !state)}>
              {filterApplyCalendarMobile
                ? `${getFormatedDate(intervalDateInit, 'dd/MM/yyyy')} a ${getFormatedDate(
                    intervalDateFinish,
                    'dd/MM/yyyy'
                  )}`
                : t('transactions.report.selectDate')}
            </StyledDateFilter>
            {filterApplyCalendarMobile && (
              <IconButton onClick={handleResetCalendarMobile}>
                <Icon id="img-cerrar-x" icon="ic-close-circle" />
              </IconButton>
            )}
          </SyledDateContainer>
        </StyledFilter>
      </LayoutSelectCalendar>
      <StyledDatePicker show={showCalendar}>
        <DatePicker
          show={showCalendar}
          setShow={setShowCalendar}
          onChange={handleChangeCalendar}
          intervalDateSelect={intervalDateCalendar}
          placeholder="Seleccionar fecha"
          minDate={moment(createdAt).toDate()}
          maxDate={moment().toDate()}
          limitDays={limitsDaysMobile}
          top="80px"
          widthMD="100%"
          topMD="6px"
          showCloseMobile={false}
        />
      </StyledDatePicker>
      <LayoutBottomMobile>
        <CleanMobile onClick={handleResetMobile} btnActive={onButtons} testId="onClickTest">
          {t('lastMovements.clean')}
        </CleanMobile>

        <ApplyMobile onClick={onClickApplyMobile} btnActive={onButtons}>
          {t('lastMovements.apply')}
        </ApplyMobile>
      </LayoutBottomMobile>
    </LayoutMobile>
  );
};

export default FiltersMobile;
